import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { makeSelectGroupName } from 'services/groups/selectors';
import { GroupsProps } from 'services/groups/types';

type OwnProps = GroupsProps;

interface ConnectedProps {
    name?: ReturnType<ReturnType<typeof makeSelectGroupName>>;
}

type Props = OwnProps & ConnectedProps;

export class GroupNameValueComponent extends React.PureComponent<Props> {
    render(): string | null {
        const { name } = this.props;
        return name || null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    name: makeSelectGroupName()
});

export default connect(mapStateToProps)(GroupNameValueComponent);
